export const csp_query_selector = 'meta[name="csp-nonce"]'
export const csp_val_attr = 'content'

export const getCspNonce = () => {
	if (typeof window === 'undefined') return null

	const metaTag = document.querySelector(csp_query_selector)
	const nonce = metaTag ? metaTag.getAttribute(csp_val_attr) : null

	return nonce
}

export const loadScriptWithNonce = (src, id, onLoad, onError) => {
	// Check if script already exists
	const existingScript = document.getElementById(id)
	if (existingScript) {
		console.log(`Script ${id} already exists`)
		onLoad && onLoad()
		return existingScript
	}

	const nonce = getCspNonce()
	console.log(`Creating script with nonce: ${nonce} for ID: ${id}`)

	const script = document.createElement('script')

	script.type = 'text/javascript'
	script.id = id
	script.src = src
	script.async = true

	// Set nonce BEFORE adding to DOM
	if (nonce) {
		script.nonce = nonce // Use .nonce property
		script.setAttribute('nonce', nonce) // Also set attribute for compatibility
		console.log(`Set nonce on script ${id}:`, script.nonce, script.getAttribute('nonce'))
	}

	script.onload = () => {
		console.log(`Script ${id} loaded successfully`)
		onLoad && onLoad()
	}
	script.onerror = onError || (() => console.error(`Failed to load script: ${src}`))

	// Use requestAnimationFrame to ensure DOM is ready
	requestAnimationFrame(() => {
		document.head.appendChild(script)

		// Verify nonce after adding to DOM
		const addedScript = document.getElementById(id)
		if (addedScript) {
			console.log(
				`Verified script ${id} nonce after DOM insertion:`,
				addedScript.getAttribute('nonce'),
			)
		}
	})

	return script
}

export const injectInlineScriptWithNonce = (code, id) => {
	// Check if script already exists
	const existingScript = document.getElementById(id)
	if (existingScript) {
		console.log(`Inline script ${id} already exists`)
		return existingScript
	}

	const nonce = getCspNonce()
	console.log(`Creating inline script with nonce: ${nonce} for ID: ${id}`)

	const script = document.createElement('script')

	script.type = 'text/javascript'
	script.id = id
	script.textContent = code // Use textContent instead of innerHTML

	// Set nonce BEFORE adding to DOM
	if (nonce) {
		script.nonce = nonce // Use .nonce property
		script.setAttribute('nonce', nonce) // Also set attribute
		console.log(`Set nonce on inline script ${id}:`, script.nonce, script.getAttribute('nonce'))
	}

	// Use requestAnimationFrame to ensure DOM is ready
	requestAnimationFrame(() => {
		document.head.appendChild(script)

		// Verify nonce after adding to DOM
		const addedScript = document.getElementById(id)
		if (addedScript) {
			console.log(
				`Verified inline script ${id} nonce after DOM insertion:`,
				addedScript.getAttribute('nonce'),
			)
		}
	})

	return script
}
